import axios from 'axios'

export default {
  async getPrakerjaDateOffsetConfig () {
    const isDevOrStaging = process.env.VUE_APP_URL_SERVER.includes('dev') || process.env.VUE_APP_URL_SERVER.includes('staging')
    const configUrl = isDevOrStaging
      ? 'https://cdn.karier.mu/config/kariermu/feature/prakerja-date-offset-config-dev.json'
      : 'https://cdn.karier.mu/config/kariermu/feature/prakerja-date-offset-config.json'
    try {
      const { data } = await axios.get(configUrl)
      return data
    } catch (error) {
      console.error(error)
    }
  }
}
